export const documentType = {
	allFile: { id: 'allFile', label: 'All' },
	document: { id: 'document', label: 'Document' },
	certificate: { id: 'certificate', label: 'Certificate' },
	combinePdf: { id: 'combinePdf', label: 'All combined in one file' },
	voidedDocuments: {id: "document", label: "Download all documents separately"}
};
